import { Component, OnInit } from '@angular/core';
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';

@Component({
    selector: 'cv-cxone-etl-reporting-set-dependencies',
    templateUrl: './cxone-etl-reporting-set-dependencies.component.html',
    styleUrls: ['./cxone-etl-reporting-set-dependencies.component.scss']
})
export class CxoneEtlReportingSetDependenciesComponent implements OnInit {
    public title: string;
    public deleteLabel: string;
    public cancelLabel: string;
    public allowClose: boolean;
    public reportingSetDependencyGridOptions: GridOptions;
    public dependencies: string[];
    public gridApi: GridApi;
    public gridColumnApi: ColumnApi;
    public deleteWarning: string;

    constructor(
        private cvLocalizationService: CVLocalizationService,
        private _dialogRef: DynamicDialogRef,
        private _dialogConfig: DynamicDialogConfig
    ) { }

    async ngOnInit() {
        await this.cvLocalizationService.GetSection('ETL_Reporting_Set');
        this.setGridOptions();
        if (this._dialogConfig.data !== null) {
            this.title = this._dialogConfig.data.title;
            this.deleteLabel = this._dialogConfig.data.saveLabel;
            this.cancelLabel = this._dialogConfig.data.cancelLabel;
            this.allowClose = this._dialogConfig.data.allowClose;
            this.deleteWarning = this._dialogConfig.data.deleteWarning;
            this.dependencies = this._dialogConfig.data.dependencies;
        }
    }

    public getLocalizationString(key: string, defaultValue: string): string {
        const baseString = this.cvLocalizationService.getCachedText("ETL_Reporting_Set", key, defaultValue);
        return baseString;
    }

    public onDismiss() {
        this._dialogRef.close();
    }

    public onDelete() {
        this._dialogConfig.data.onDelete();
        this._dialogRef.close();
    }

    public setGridOptions() {
        this.reportingSetDependencyGridOptions = {
            columnDefs: [
                {
                    field: 'Metrics',
                    colId: 'Metrics',
                    headerName: this.getLocalizationString("Metrics", "Metrics"),
                    resizable: true
                }
            ],
            onGridReady: (event: GridReadyEvent) => this.onGridReady(event),
            context: this,
            rowHeight: 36,
            headerHeight: 44,
            animateRows: true,
            scrollbarWidth: 8
        };
    }

    public onGridReady(event) {
        this.gridApi = event.api;
        this.gridColumnApi = event.columnApi;
        this.gridApi.setGridOption('columnDefs', this.reportingSetDependencyGridOptions.columnDefs);
        this.gridApi.setGridOption('rowData', this.dependencies);
        this.gridApi.sizeColumnsToFit();
    }
}
